export default __webpack_public_path__ + "static/media/reactjs.56db227c.png";